<template>
  <div>
    <b-loading :is-full-page="true" :active="loading"></b-loading>
    <section v-if="!loading" class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Quick Links</h1>
        </div>
        <div class="columns is-vcentered is-multiline">
          <div class="column is-12 has-text-centered">
            <b-button
              type="is-primary"
              tag="router-link"
              :to="{ name: 'ManageAllMedia' }"
              >Manage Media</b-button
            >
            <b-button
              type="is-primary"
              :disabled="loading"
              class="has-margin-left-5"
              :class="{ 'is-loading': loading }"
              @click="exportCatchupSchedule"
            >
              Export Catchup Schedule</b-button
            >
            <b-button
              type="is-primary"
              tag="router-link"
              class="has-margin-left-5"
              :to="{ name: 'ManageChannels' }"
              >Manage Channels</b-button
            >
          </div>
        </div>
        <div class="has-text-centered">
          <h1 class="title">Channels</h1>
        </div>
        <div
          v-for="channel in channels"
          class="column is-12 has-text-centered has-margin-top-15"
        >
          <h1 class="is-size-4 has-text-weight-bold">{{ channel.name }}</h1>
          <b-button
            type="is-primary"
            class="has-margin-left-5"
            tag="router-link"
            :to="{ name: 'EditSchedule', params: { id: channel.id } }"
            >Edit Schedule</b-button
          >
          <b-button
            type="is-primary"
            :disabled="loading"
            class="has-margin-left-5"
            :class="{ 'is-loading': loading }"
            @click="exportEpg(channel)"
          >
            Export EPG</b-button
          >
          <b-button
            type="is-primary"
            :disabled="loading"
            class="has-margin-left-5"
            :class="{ 'is-loading': loading }"
            @click="exportNielsen(channel)"
          >
            Export Nielsen</b-button
          >
          <b-button
            type="is-primary"
            :disabled="loading"
            class="has-margin-left-5"
            :class="{ 'is-loading': loading }"
            @click="exportBreakSchedule(channel)"
          >
            Export Break Schedule</b-button
          >
          <b-button
            type="is-primary"
            :disabled="loading"
            class="has-margin-left-5"
            :class="{ 'is-loading': loading }"
            @click="exportProduction(channel)"
          >
            Export Production</b-button
          >
        </div>
      </CardComponent>
    </section>
    <ExportCatchupScheduleModal
      v-if="showExportCatchupScheduleModal"
      :show="showExportCatchupScheduleModal"
      @close-modal="showExportCatchupScheduleModal = false"
    >
    </ExportCatchupScheduleModal>
    <ExportScheduleModal
      v-if="showExportScheduleModal"
      :show="showExportScheduleModal"
      :start="lastStartDate"
      :end="lastEndDate"
      :channel-id.sync="channel.id"
      :report-type="reportType"
      :channel-name="channel.name"
      @close-modal="showExportScheduleModal = false"
    >
    </ExportScheduleModal>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent'
import ChannelApi from '@/api/channels'
import ExportCatchupScheduleModal from '@/components/ExportCatchupScheduleModal'
import ExportScheduleModal from '@/components/ExportScheduleModal'

export default {
  name: 'Home',
  components: {
    CardComponent,
    ExportCatchupScheduleModal,
    ExportScheduleModal
  },
  metaInfo: {
    title: 'Home'
  },
  data() {
    return {
      loading: true,
      showExportCatchupScheduleModal: false,
      showExportScheduleModal: false,
      channels: [],
      channel: {},
      reportType: ''
    }
  },
  async created() {
    this.channels = await ChannelApi.getAll()
    this.loading = false
  },
  methods: {
    exportCatchupSchedule() {
      this.showExportCatchupScheduleModal = true
    },
    async exportEpg(channel) {
      this.channel = channel
      this.showExportScheduleModal = true
      this.reportType = 'epg'
    },
    async exportNielsen(channel) {
      this.channel = channel
      this.showExportScheduleModal = true
      this.reportType = 'nielsen'
    },
    async exportBreakSchedule(channel) {
      this.channel = channel
      this.showExportScheduleModal = true
      this.reportType = 'break'
    },
    async exportProduction(channel) {
      this.channel = channel
      this.showExportScheduleModal = true
      this.reportType = 'production'
    }
  }
}
</script>
